import React from "react";

function Checkbox({
    item,
    onChange
}) {
    return (
        <div className="form-check flex-grow-1">
            <label className="form-label">{item.name}</label>
            <input
                type="checkbox"
                name="value"
                className="form-check-input"
                style={{ width: '20px', height: '20px' }}
                checked={item.value === 'checked' ?? false}
                onChange={onChange}
                disabled={onChange ? false : true}
            />
        </div>
    );
};

export default Checkbox;